<template>
  <div>
    <Row v-if="bussiness.category=='S'">
      <Row class="detail-content">
        <slot name="info-title"></slot>
        <Col :span="labelWidth" class="left-label">{{ $t('EntityNature') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.property=='P'?$t('Individual'):(bussiness.property=='E'?$t('EnterpriseCompany'):$t('proprietorship')) }}</Col>
        <Col :span="labelWidth" class="left-label">{{ $t('EntityName') }}：</Col>
        <Col :span="contentWidth" class="right-content textover" :title="bussiness.name">{{ bussiness.name }}</Col>

        <Col :span="labelWidth" class="left-label">{{ $t('EntityTag') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.type=='E'?$t('BusinessEntity'):(bussiness.type=='B'?$t('BillingEntity'):$t('POSEntity')) }}</Col>
        <Col :span="labelWidth" class="left-label">{{ bussiness.property=='P'?$t('IDNumber'):$t('CreditCode') }}：</Col>
        <Col :span="contentWidth" class="right-content textover" :title="bussiness.legalRepresentative">
          {{ bussiness.creditCode || "" }}
        </Col>

        <Col v-if="bussiness.property!='P'" :span="labelWidth" class="left-label">{{ bussiness.property=='E'?$t('LegalRepresentative'):$t('Operator') }}：</Col>
        <Col
          v-if="bussiness.property!='P'" :span="contentWidth" class="right-content textover"
          :title="bussiness.legalRepresentative"
        >
          {{ bussiness.legalRepresentative }}
        </Col>
        <Col :span="labelWidth" class="left-label">{{ $t('ContactInformation') }}：</Col>
        <Col :span="contentWidth" class="right-content textover">{{ bussiness.contact }}</Col>

        <Col :span="labelWidth" class="left-label">{{ $t('EntityRegion') }}：</Col>
        <Col
          :span="contentWidth" class="right-content textover"
          :title="bussiness.provinceName+bussiness.cityName+bussiness.areaName"
        >
          {{ bussiness.provinceName }} {{ bussiness.cityName }} {{ bussiness.areaName }}
        </Col>
        <Col :span="labelWidth" class="left-label">{{ $t('BusinessRegistrationAddress') }}：</Col>
        <Col :span="contentWidth" class="right-content textover" :title="bussiness.address">{{ bussiness.address }}</Col>
        <Col v-if="identifyShow" :span="labelWidth" class="left-label">{{ $t('determinationImage') }}：</Col>
        <Col v-if="identifyShow" :span="contentWidth" class="right-content">
          <file-upload
            :base-url="baseUrl"
            :default-list="bussiness.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
        <Col v-if="identifyShow" :span="labelWidth" class="left-label">{{ $t('determinationImage') }}：</Col>
        <Col v-if="identifyShow" :span="contentWidth" class="right-content textover">{{ bussiness.identifyRemark || "" }}</Col>
      </Row>
    </Row>
    <Row v-if="bussiness.category=='M'">
      <Row class="detail-content">
        <slot name="info-title"></slot>
        <Col :span="labelWidth" class="left-label">{{ $t('Manufacturer') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.name || "" }}</Col>
        <Col :span="labelWidth" class="left-label">{{ $t('CreditCode') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.creditCode || "" }}</Col>
        <Col :span="labelWidth" class="left-label">{{ $t('LegalRepresentative') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.legalRepresentative || "" }}</Col>
        <Col :span="labelWidth" class="left-label">{{ $t('ContactInformation') }}：</Col>
        <Col :span="contentWidth" class="right-content textover">{{ bussiness.contact || "" }}</Col>
        <Col :span="labelWidth" class="left-label">{{ $t('EntityRegion') }}：</Col>
        <Col :span="contentWidth" class="right-content" :title="bussiness.provinceName+bussiness.cityName+bussiness.areaName">
          {{ bussiness.provinceName || "" }} {{ bussiness.cityName || "" }} {{ bussiness.areaName || "" }}
        </Col>
        <Col :span="labelWidth" class="left-label">{{ $t('BusinessRegistrationAddress') }}：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.address || "" }}</Col>
        <Col v-if="identifyShow" :span="labelWidth" class="left-label">{{ $t('determinationImage') }}：</Col>
        <Col v-if="identifyShow" :span="contentWidth" class="right-content">
          <file-upload
            :base-url="baseUrl"
            :default-list="bussiness.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
        <Col v-if="identifyShow" :span="labelWidth" class="left-label">{{ $t('determinationDescription') }}：</Col>
        <Col v-if="identifyShow" :span="contentWidth" class="right-content textover">{{ bussiness.identifyRemark || "" }}</Col>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    defaultData: {
      type: Object,
      default() {
        return {}
      }
    },
    double: {
      type: Boolean,
      default: true
    },
    identifyShow: {
      type: Boolean,
      default: false
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bussiness: {},
      labelWidth: '3',
      contentWidth: '8'
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.bussiness = this.defaultData
    if (this.double) {
      this.labelWidth = '3'
      this.contentWidth = '8'
    } else {
      this.labelWidth = '5'
      this.contentWidth = '16'
    }
  },
  updated() {},
  methods: {}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/clue/plugin/tortSubjectInfo.vue